export const CART_ACTION_TYPES = {
  SET_CART_ITEMS: "cart/SET_CART_ITEMS",
  SET_CART_COUNT: "cart/SET_CART_COUNT",
  SET_CART_TOTAL: "cart/SET_CART_TOTAL",
  SET_WHOLE_CART: "cart/SET_WHOLE_CART",
  TOGGLE_CART: "cart/TOGGLE_CART",
  ANIME_CART: "cart/ANIME_CART",
  DELETE_CART: "cart/DELETE_CART",
  REUSE_PREVIOUS_CART: "cart/REUSE_PREVIOUS_CART",
};
